import AirDatepicker from 'air-datepicker';
import localeRu from 'air-datepicker/locale/ru';
import localeUk from 'air-datepicker/locale/uk';
import 'air-datepicker/air-datepicker.css';

const dataStorage = {
    heading: '',
    region: '',
    date: '',
}

const todayBtn = document.querySelector('.datepicker__today');
const filtersShowBtn = document.querySelector('.filters-show-btn');
const filtersHideBtn = document.querySelector('.filters-close-icon');

// dropdown btns
const dropdownBtnHeadings = document.querySelector('#headings-dropdown-btn');
const dropdownBtnRegions = document.querySelector('#regions-dropdown-btn');

const filtersSidebar = document.querySelector('.filters-sidebar');
const searchBtn = document.querySelector('.datepicker__btn');

function toggleDropdownContent(e, id) {
    document.getElementById(id).classList.toggle("dropdown_show");
}

function toggleMenuHandler(e) {
    if (!e.target.matches('.dropdown__btn')
        && !e.target.matches('.dropdown__btn-icon')
        && !e.target.matches('.dropdown__btn-text')) {
        if (e.target.classList.contains('dropdown__item')) {
            const dropdownBtn = e.target.parentElement.parentElement.querySelector('button');

            // select option value
            if (dropdownBtn.id === 'headings-dropdown-btn')
                dataStorage.heading = e.target.dataset.value;

            if (dropdownBtn.id === 'regions-dropdown-btn')
                dataStorage.region = e.target.dataset.value;

            dropdownBtn.children[0].innerHTML = e.target.textContent;
            dropdownBtn.classList.add('dropdown__btn_selected');
        }
        const dropdowns = document.getElementsByClassName("dropdown__content");
        for (let i = 0; i < dropdowns.length; i++) {
            const openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('dropdown_show'))
                openDropdown.classList.remove('dropdown_show');
        }
    }
}

window.addEventListener('click', toggleMenuHandler);

// dropdown togglers
dropdownBtnHeadings.addEventListener('click', (e) => toggleDropdownContent(e, "headings-dropdown"));
dropdownBtnRegions.addEventListener('click', (e) => toggleDropdownContent(e, "regions-dropdown"));

const LOCALES = new Map([
    ['ru', localeRu],
    ['uk', localeUk]
]);
// get locale from URL prefix
// get URL path
const urlPath = window.location.pathname;
// get locale from URL path
const pathPart = urlPath.split('/')[1];
// check if pathPart is in LOCALES

let locale;
if (LOCALES.has(pathPart)) {
    locale = LOCALES.get(pathPart);
} else {
    locale = LOCALES.get('uk');
}


let todayButton = {
    content: locale.today,
    className: 'air-datepicker-button',
    onClick: (dp) => {
        let date = new Date();
        dp.selectDate(date);
        dp.setViewDate(date);
    }
}

// TODO: Translations
const picker = new AirDatepicker('#date', {
    inline: true,
    buttons: [todayButton, 'clear'],
    locale: locale,
    navTitles: {
        days: '<i>MMMM </i> &nbsp; <strong> yyyy</strong> ',
        // months: 'Select month of <strong>yyyy</strong>'
    },
});

// select initial date
document.addEventListener('DOMContentLoaded', function () {
    const newParams = new URLSearchParams(window.location.search);
    const dateTime = newParams.get('date');
    if (dateTime) {
        const dateObj = new Date(dateTime);
        // subtract 1 day from date
        dateObj.setDate(dateObj.getDate());
        picker.selectDate(dateObj);
        picker.setViewDate(dateObj);
    }
    const categoryId = newParams.get('category');
    if (categoryId) {
        dataStorage.heading = categoryId;
    }
});

document.querySelector('#filter-button').addEventListener('click', function (e) {
    debugger;
    let tab_content = document.querySelector(`#filter-button`);
    let search = tab_content.dataset.search;
    let ds = dataStorage;
    const newParams = new URLSearchParams(window.location.search);
    // add search to url using URLSearchParams
    if (search) {
        newParams.set('search', search);
    } else {
        newParams.delete('search');
    }
    if (ds.heading) {
        newParams.set('category', ds.heading);
    } else {
        newParams.delete('category');
    }
    if (picker.selectedDates[0]) {
        const day = picker.selectedDates[0].getDate();
        const month = picker.selectedDates[0].getMonth() + 1;
        const year = picker.selectedDates[0].getFullYear();
        newParams.set('date', `${year}-${month}-${day}`);
    } else {
        newParams.delete('date');
    }

    // Update URL with new parameters
    const url = new URL(window.location.href)
    url.search = newParams.toString();
    window.location.href = url.toString();
    // window.history.pushState({path: url}, '', url);


    // Reload page with new URL
    // window.location.reload();
});

// filtersShowBtn.addEventListener('click', () => {
//     filtersSidebar.style.display = 'block';
// });

// filtersHideBtn.addEventListener('click', () => {
//   filtersSidebar.style.display = 'none';
// });